import { css } from '@emotion/react';
import { BannerRow } from '@models/banner';
import { Dispatch, SetStateAction } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import PopupBanner from './PopupBanner';

interface Props {
    banners?: BannerRow[];
    setIndex: Dispatch<SetStateAction<number>>;
}

function BannerList({ banners, setIndex }:Props) {
    return (
        <Swiper loop css={css`width: 100%`}
            slidesPerView={1}
            autoplay={{ delay: 2000 }}
            modules={[Autoplay]}
            onSlideChange={(swiper) => {
                setIndex(swiper.realIndex);
            }} >
            {banners?.map((banner) => (
                <SwiperSlide key={banner.imageUrl}>
                    <PopupBanner banner={banner} />
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default BannerList;
